import { iLocker } from '@/Engine/apiInterfaces';
import { Section } from '@/Engine/Section';
import { Object3D, Vector3 } from 'three';
import { IV3D } from '@/Interfaces/v3d';
import { Item } from '@/Engine/Item';
import { depth, height } from '@/Constants/modelMeta';
import { ShadowWall } from '@/Engine/ShadowWall';

declare let v3d: IV3D;
export class Locker {
    bodyColor = '#ffffff';
    doorColor = '#ffffff';
    // top: string | null = null;
    // bottom: string | null = null;
    sections: Section[] = [];
    shadowWalls: ShadowWall[] = [];
    public model: Object3D;

    constructor(props: iLocker) {
        this.model = new v3d.Group();
        this.bodyColor = props.body_color;
        this.doorColor = props.door_color;
        // this.top = props.top;
        // this.bottom = props.bottom;
        let xShift = 0;
        let yShift = 0;
        const zShift = 0;

        props.sections.forEach((section)=>{
            const sectionItem = new Section(section,  this.bodyColor, this.doorColor, props.show_doors);
            if (props.bottom.length && props.bottom[0].bottomType === 'bench') {
                sectionItem.hasLegs = 'b';
                // yShift = 0.156;
                yShift = 0.3;
            }


            if (props.bottom.length &&
                [ 'headLegs', 'additionalLegs' ].includes(props.bottom[0].bottomType)) {
                sectionItem.hasLegs = 'p';
                yShift = 0.153;
            }
            sectionItem.position = sectionItem.position.add(new Vector3(xShift, yShift, zShift)) ;
            xShift += sectionItem.width + 0.0002;
            this.model.add(sectionItem.model);
            this.sections.push(sectionItem);

        });

        props.bottom.forEach((bottom, index) => {
            if (!this.sections[index]) return;
            const bottomItem = new Item(bottom);
            bottomItem.setColor(this.bodyColor);
            bottomItem.model.position.set(
                this.sections[index].position.x,
                this.sections[index].position.y,
                0,
            );
            // bottomItem.model.position.add(new Vector3(-0.001,0,0));
            this.model.add(bottomItem.model);
        });

        props.top.forEach((top, index) => {
            if (!this.sections[index]) return;
            this.sections[index].hasTop = 't';
            let yPlusShift = 0;
            if (this.sections[index].name === 'ls_11_50') {
                yPlusShift = 0.042;
            }
            const topItem = new Item(top);
            topItem.setColor(this.bodyColor);
            topItem.model.position.set(
                this.sections[index].position.x,// + 0.001,
                yShift + height/1000 + yPlusShift - 0.024,
                0,
            );
            topItem.model.rotation.set(0,0,0);
            // topItem.model.position.add(new Vector3(-0.002,0,0.013));
            this.model.add(topItem.model);
        });

        props.sections.forEach((section, index)=>{
            const shadowWallProps = JSON.parse(JSON.stringify(section));
            shadowWallProps.blender_name = shadowWallProps.blender_name.replace('ml', 'wf');
            shadowWallProps.blender_name = shadowWallProps.blender_name.replace('ls', 'wf');
            const shadowWallItem = new ShadowWall(
                shadowWallProps,
                this.sections[index].nomWidth ?? this.sections[index].width,
                this.sections[index].position.x,
                this.sections[index].hasTop,
                this.sections[index].hasLegs,
                this.sections[index].door.isOpen,
            );
            this.shadowWalls.push(shadowWallItem);
            this.model.add(shadowWallItem.model);
        });
    }

    hideWalls() {
        this.shadowWalls.forEach((shadowWall) => {
            shadowWall.hide();
        });
    }


    openDoors() {
        this.sections.forEach(section => {
            section.door.open();
        });
    }

    closeDoors() {
        this.sections.forEach(section => {
            section.door.close();
        });
    }

    get width(): number {
        return this.sections.reduce((sum, section) => sum + section.width, 0);
    }

    get center(): Vector3 {
        return this.model.position
            .clone()
            .add(new Vector3(this.width/2,height/2000, depth/2000));
    }

    get cameraPosition(): Vector3 {
        return this.center
            .clone()
            .add(new Vector3(-1, 2, 5));
    }

    destroy() {
        this.model.removeFromParent();
        this.sections.forEach((section)=>{
            section.destroy();
        });
        this.shadowWalls.forEach((shadowWall)=>{
            shadowWall.destroy();
        });
    }
}
